<ng-container *ngIf="organisation else asRoot">
    <ng-container *ngTemplateOutlet="overview"></ng-container>
</ng-container>
<ng-template #asRoot>
    <div class="main-content">
        <div class="container-fluid">
            <div class="justify-content-center row">
                <div class="col-12">
                    <div class="header">
                        <div class="header-body">
                            <div class="align-items-center row">
                                <div class="col"><h6 class="header-pretitle">Overview</h6>
                                    <h1 class="header-title text-truncate">Connections</h1></div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="overview"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #overview>
    <app-overview [query]="query" (dataChange)="data = $event" [windowScroll]="true">
        <div class="header-bar align-items-center row mb-4 g-3">
            <div class="col">
                <app-filter [(filterTerm)]="term" (onUpdate)="executeQuery()" placeholder="Search"></app-filter>
            </div>
            <div class="col-auto">
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                        <i class="bi bi-download me-md-2"></i>
                        <span class="d-none d-md-inline">Download</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <button class="dropdown-item" (click)="downloadConnectionsAsExcel()">Connections list
                            </button>
                        </li>
                        <li *ngIf="appContext.isAdminOrIntermediary() && !organisation">
                            <button class="dropdown-item notranslate" (click)="downloadAsEdsnCsv()">EDSN CSV</button>
                        </li>
                        <hr class="dropdown-divider"/>
                        <li>
                            <button class="dropdown-item" (click)="toggleSelection()">Measurement data</button>
                        </li>
                        <li>
                            <button class="dropdown-item" (click)="bulkDownloading = !bulkDownloading">Monthly measurement
                                data
                            </button>
                        </li>
                        <li *ngIf="appContext.isAdminOrIntermediary()">
                            <a href="/assets/templates/data-import-template.xlsx" class="dropdown-item">
                                Connection monthly data template
                            </a>
                        </li>
                        <li *ngIf="appContext.isAdminOrIntermediary()">
                            <a href="/assets/templates/data-import-raw-template.xlsx" class="dropdown-item">
                                Raw connection data template
                            </a>
                        </li>
                        <li *ngIf="appContext.isAdminOrIntermediary()">
                            <button class="dropdown-item"
                                    (click)="downloadMeterAuthorisationPeriods()">Meter authorisation periods
                            </button>
                        </li>
                        <li *ngIf="appContext.isAdminOrIntermediary()">
                            <button class="dropdown-item"
                                    (click)="downloadMeterList()">Meter list
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-auto" *ngIf="appContext.isAdminOrIntermediary()">
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                        <i class="bi bi-upload me-md-2"></i>
                        <span class="d-none d-md-inline">Upload</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a type="button" class="dropdown-item" (click)="uploadConnectionsListInput.click()">
                                <span>Connections list</span>
                                <input type="file" hidden (change)="onUploadConnectionsList($event.target);"
                                       #uploadConnectionsListInput>
                            </a>
                        </li>
                        <li>
                            <a type="button" class="dropdown-item" (click)="uploadConnectionDataInput.click()">
                                <span>Monthly connection data</span>
                                <input type="file" hidden (change)="onUploadConnectionData($event.target);"
                                       #uploadConnectionDataInput>
                            </a>
                        </li>
                        <li>
                            <a type="button" class="dropdown-item" (click)="uploadMinuteDataInput.click()">
                                <span>Raw connection data</span>
                                <input type="file" hidden (change)="uploadMinuteData($event.target);" #uploadMinuteDataInput>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()" class="col-auto">
                <button (click)="createNewConnection()" type="button" class="btn btn-primary">
                    <i class="bi bi-plus me-md-2"></i>
                    <span class="d-none d-md-inline">Add connection</span>
                </button>
            </div>
            <div *ngIf="selecting" class="col-12">
                <app-status-alert [type]="'info'"><span>Select one or more connections</span></app-status-alert>
            </div>
        </div>
        <div class="overview-items pb-4">
            <div class="row mx-0">
                <ng-container *ngFor="let record of data; trackBy: trackByForRecord">
                    <div role="row" class="col-xl-4 col-md-6 col-12">
                        <app-connections-overview-item class="h-100 d-flex" [entity]="record" [selecting]="selecting"></app-connections-overview-item>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
            <span class="h1 mb-2">No connections found</span>
            <span class="text-secondary">Try adjusting your filters or search term</span>
        </div>
    </app-overview>
    <div class="sticky-bottom bg-white mx-n3 mx-md-n5 border-top top-shadow">
        <app-connection-selection *ngIf="selecting" [comparator]="refDataUtils.connectionsComparator" [selectedItems]="selectedRecords"
                                  [csvMapper]="connectionCsvDataToJson" [onDownloaded]="toggleSelection"
                                  [cancelMethod]="toggleSelection" [sheetTemplate]="connectionDataTemplate"></app-connection-selection>
    </div>
    <div *ngIf="bulkDownloading" class="sticky-bottom bg-white mx-n3 mx-md-n5 border-top top-shadow">
        <div class="row mx-0 p-3 px-md-5 g-3 gy-md-0 justify-content-between">
            <div class="col-12 col-md" style="max-width: 25rem">
                <app-date-range [(ngModel)]="bulkDownloadTimeRange" [ranges]="dashboardContext.defaultRanges"
                                [dateOnly]="true"></app-date-range>
            </div>
            <div class="col-12 col-md">
                <app-sources-selector positionClass="position-fixed" [sourceProvider]="sourceProvider"></app-sources-selector>
            </div>
            <div class="col-md-auto ms-auto">
                <button class="btn btn-outline-danger mx-1 w-100" (click)="bulkDownloading = !bulkDownloading" type="button">
                    Cancel
                </button>
            </div>
            <div class="col-md-auto">
                <button class="btn btn-outline-info mx-1 w-100" (click)="bulkDownloadMonthData($event)" type="button">
                    <i class="bi bi-download me-md-2"></i>
                    Download
                </button>
            </div>
        </div>
    </div>
</ng-template>